// extracted by mini-css-extract-plugin
module.exports = {"technologiesWrapper":"technologies-list_technologiesWrapper__H5nav"};